import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const ITEM_HEIGHT = 48;

export default function ButtonWithMenu({ icon, selectOption, options, className, disabled }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedSubOptions, setSelectedSubOptions] = useState([]);
  const [showSubOptions, setShowSubOptions] = useState(false);
  let open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (selectedSubOption) => {
    selectOption(selectedOption, selectedSubOption);
    setSelectedOption(null);
    setSelectedSubOptions([]);
    setShowSubOptions(false);
    setAnchorEl(null);
  };

  const showSelectedSubOptions = (selectedOption) => {
    setSelectedOption(selectedOption);
    const subOptions = options.find(option => option?.title === selectedOption).subOptions;
    if (!subOptions) {
      selectOption(selectedOption);
      setSelectedOption(null);
      setAnchorEl(null);
    } else {
      setSelectedSubOptions(subOptions);
      setShowSubOptions(true);
    }
  }

  return (
    <>

      <button
        className={className}
        disabled={disabled}
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        {icon}
      </button>


      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          },
        }}
      >
        {!showSubOptions && options.map((option) => (
          <MenuItem key={option.title} onClick={(event) => showSelectedSubOptions(event.target.textContent)}>
            {option.title}
          </MenuItem>
        ))}
        {showSubOptions && selectedSubOptions.map((subOption) => (
          <MenuItem key={subOption} onClick={(event) => handleClose(event.target.textContent)}>
            {subOption}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}